import FetchBase from '../Api/FetchBase'
import { observable, action } from 'mobx'
import { API_ENDPOINTS } from '../Utils/constants'
import { generateFormData } from '../Utils/helpers'

export default class UsersStore extends FetchBase {
  @observable faqQuestionsUserViewLoader = false
  @observable faqQuestionsUserViewList = []

  @observable allFaqList = []
  @observable faqHeaderList = []
  @observable faqQuestionsList = []
  @observable faqListLoader = false

  @observable addFaqQuestionAndHeaderLoader = false
  @observable updateFaqQuestionAndHeaderLoader = false
  @observable deleteFaqTemplateLoader = false

  @observable faqCategoryDropdown = []
  @observable faqCategoryLoader = false
  @observable faqCategoryList = []
  @observable addFaqCategoryLoader = false

  @action.bound
  getFaqHeader = async () => {
    try {
      let response = await this.get(API_ENDPOINTS.GET_FAQ_LIST)
      if (response.status) {
        this.faqHeaderList = response.data?.faqHeader || []
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  getAllFaqList = async (values) => {
    try {
      this.faqListLoader = true
      let options = { ...values }
      !options?.categoryId && delete options['categoryId']
      let response = await this.get(API_ENDPOINTS.GET_FAQ_LIST, { ...options })
      if (response.status) {
        this.allFaqList = response.data
        this.faqQuestionsList = response.data?.faqQuestions || []
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.faqListLoader = false
    }
  }

  @action.bound
  getAllFaqUserViewList = async (values) => {
    try {
      this.faqQuestionsUserViewLoader = true
      let options = { ...values }
      let response = await this.get(API_ENDPOINTS.GET_FAQ_LIST, { ...options })
      if (response.status) {
        this.faqQuestionsUserViewList = response.data?.faqQuestions || []
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.faqQuestionsUserViewLoader = false
    }
  }

  @action.bound
  addFaqQuestionAndHeader = async (values) => {
    try {
      this.addFaqQuestionAndHeaderLoader = true
      let formDataValues = generateFormData(values)
      let response = await this.postWithFormData(
        API_ENDPOINTS.Add_FAQ_QUESTIONS_AND_HEADER,
        formDataValues
      )
      if (response.status) {
        return [true, response?.data]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.addFaqQuestionAndHeaderLoader = false
    }
  }

  addFaqQuestionLocally = async (values) => {
    this.faqQuestionsList = [...this.faqQuestionsList, values]
  }

  @action.bound
  updateFaqQuestionAndHeader = async (values) => {
    try {
      this.updateFaqQuestionAndHeaderLoader = true
      let formDataValues = generateFormData(values)
      let response = await this.postWithFormData(
        API_ENDPOINTS.UPDATE_FAQ_QUESTIONS_AND_HEADER,
        formDataValues
      )
      if (response.status) {
        return [true, response?.data]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.updateFaqQuestionAndHeaderLoader = false
    }
  }

  updateFaqQuestionLocally = async (id, values) => {
    this.faqQuestionsList = (this.faqQuestionsList || []).map((question) => {
      if (id === question?.id) {
        return values
      } else {
        return question
      }
    })
  }

  @action.bound
  deleteFaqTemplateById = async (faqId) => {
    try {
      this.deleteFaqTemplateLoader = true
      let response = await this.post(
        API_ENDPOINTS.DELETE_FAQ_QUESTIONS_AND_HEADER,
        { faqId }
      )
      if (response.status) {
        return [true, response.status]
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.deleteFaqTemplateLoader = false
    }
  }

  locallyDeleteFaqTemplateById = (id) => {
    this.faqQuestionsList = (this.faqQuestionsList || []).filter(
      (template) => template?.id !== id
    )
  }

  @action.bound
  deleteFaqMediaFileById = async (id) => {
    try {
      let response = await this.post(API_ENDPOINTS.DELETE_FAQ_ATTACHMENT, {
        id,
      })
      if (response.status) {
        return [true, response?.data]
      }
    } catch (err) {
      return [false, undefined]
    }
  }

  locallyDeleteMediaFileById = async (id) => {
    this.faqQuestionsList = (this.faqQuestionsList || []).map((question) => {
      if (id === question?.id) {
        delete question.fileName
        delete question.fileType
        delete question.url
        return question
      } else {
        return question
      }
    })
  }

  @action.bound
  getCategoryDropdown = async () => {
    try {
      let response = await this.get(API_ENDPOINTS.GET_FAQ_CATEGORY)
      if (response.status) {
        this.faqCategoryDropdown = response.data || []
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  setFaqCategoryOrdering = async (value = []) => {
    this.faqCategoryOrder = value
  }

  getAllFaqCategoryList = async () => {
    try {
      this.faqCategoryLoader = true
      const res = await this.get(API_ENDPOINTS.GET_FAQ_CATEGORY)
      if (res?.status) {
        this.faqCategoryList = res?.data || []
        return [true, res?.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.faqCategoryLoader = false
    }
  }

  addFaqCategory = async (value = {}) => {
    try {
      this.addFaqCategoryLoader = true
      let res = await this.post(API_ENDPOINTS.ADD_FAQ_CATEGORY, { ...value })
      if (res.status) {
        return [true, res.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.addFaqCategoryLoader = false
    }
  }

  addCategoryLocallay = async (value = {}) => {
    this.faqCategoryList = [...this.faqCategoryList, value]
  }

  @action.bound
  updateCategoryById = async (values) => {
    try {
      this.addFaqCategoryLoader = true
      let response = await this.post(API_ENDPOINTS.UPDATE_FAQ_CATEGORY, {
        ...values,
      })
      if (response.status) {
        return [true, response?.data]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.addFaqCategoryLoader = false
    }
  }

  updateCategoryByIdLocally = async (id, values) => {
    this.faqCategoryList = (this.faqCategoryList || []).map((category) => {
      if (id === category?.id) {
        return values
      } else {
        return category
      }
    })
  }

  deleteCategoryById = async (id = undefined) => {
    try {
      let res = await this.post(API_ENDPOINTS.DELETE_FAQ_CATEGORY, {
        categoryId: id,
      })
      if (res?.status) {
        return [true, res.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  // Drag and Drop features
  @action.bound
  reorderFaqCategoryLocally = (newFaqCategory = this.faqCategoryList || []) => {
    this.faqCategoryList = [...newFaqCategory]
  }

  @action.bound
  reorderFaqCategory = async ({ newCategoryOrder = [] } = {}) => {
    try {
      let response = await this.post(API_ENDPOINTS.REORDER_FAQ_CATEGORY, {
        newCategoryIdsInOrder: newCategoryOrder,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  // Drag and Drop Questions
  @action.bound
  reorderFaqQuestionLocally = (
    newFaqQuestion = this.faqQuestionsList[0]?.faqQuestion || []
  ) => {
    this.faqQuestionsList[0].faqQuestion = [...newFaqQuestion]
  }

  @action.bound
  reorderFaqQuestion = async ({
    categoryId = undefined,
    newFaqOrder = [],
  } = {}) => {
    try {
      let response = await this.post(API_ENDPOINTS.REORDER_FAQ_QUESTIONS, {
        categoryId: categoryId,
        newFaqIdsInOrder: newFaqOrder,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  resetStore = () => {
    this.faqQuestionsUserViewLoader = false
    this.faqQuestionsUserViewList = []
    this.allFaqList = []
    this.faqHeaderList = []
    this.faqQuestionsList = []
    this.faqListLoader = false
    this.addFaqQuestionAndHeaderLoader = false
    this.updateFaqQuestionAndHeaderLoader = false
    this.deleteFaqTemplateLoader = false

    this.faqCategoryDropdown = []
    this.faqCategoryLoader = false
    this.faqCategoryList = []
    this.addFaqCategoryLoader = false
  }
}
